/* -----------------------------------------------------------------------------
 * User SM State
 *
 * @description - State of User SM. Check ./README.md for more info.
 * -----------------------------------------------------------------------------
 */

import { _cfg } from '@/config'

export default {

  // User info
  user: {
    name: '',
    surname: '',
    patronymic: '',
    email: '',
    password: '',
    phone: '',
    agreement: false,
    uuid: '' // user unique id after reg user
  },

  // Poll
  poll: {
    prototype: null, // fetch from server
    answers: []
  },

  // SMS logic
  sms: {
    sms_code: '', // sms verify code
    uuid: '', // sms uuid for confirmation
    codeConfirmed: false,
    smsWasSent: false,
    regComplete: false
  },

  // Portfolio
  portfolio: {
    mode: _cfg.common.modes[0],
    deposit: _cfg.deposit.start,
    profits: [], // risk points
    tickers: [], // portfolio tickers
    checkOnlyBonds: false, // only bonds mode
    risk: null, // default risk point obj
    riskProfiles: null, // after poll complete
    riskLimit: 100 // not limited by default // 0 ... 100
  },

  // Terms
  terms: null, // Terms data

  // Tracking
  tracking: null

}
